import Vue from 'vue'
import VueRouter from 'vue-router'
import Axios from 'axios'
import VueGtm from 'vue-gtm'
import VueCookie from 'vue-cookie'
import store from './checkout/store'
import App from './checkout/components/App.vue'
import Cart from './checkout/components/pages/Cart.vue'
import Payment from './checkout/components/pages/Payment.vue'
import Success from './checkout/components/pages/Success.vue'

// this is required to allow webpack to load the chunk data
// it takes the URL that this script was loaded from, then appends the public path
let url = ''
if (document.currentScript) {
  url = (new URL(document.currentScript.src)).origin
} else {
  if (window.location.origin) {
    url = window.location.origin
  } else {
    url = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
  }
}
__webpack_public_path__ = url + __webpack_public_path__ // eslint-disable-line

Axios.defaults.baseURL = '/checkout'
Axios.defaults.method = 'post'
Axios.defaults.xsrfCookieName = 'CSRF-TOKEN'
Axios.defaults.xsrfHeaderName = 'X-CSRF-TOKEN'
Axios.defaults.responseType = 'json'
Axios.defaults.timeout = 30000
Axios.interceptors.request.use(
  config => {
    // If we update the address, it means we recalculate the tax rate.
    if (
      config.url.includes('/cart/update') &&
      config.data !== undefined &&
      config.data.userAddress !== undefined
    ) {
      store.dispatch('globalstate/setTaxChangeLoading')
    } else {
      store.dispatch('globalstate/addToLoading', config.url)
    }
    store.dispatch('globalstate/clearMessages')
    return config
  },
  error => {
    store.dispatch('globalstate/clearLoading')
    throw error
  }
)
Axios.interceptors.response.use(
  response => {
    if (store.state.globalstate.taxChangeLoading === true) {
      store.dispatch('globalstate/unsetTaxChangeLoading')
    }
    store.dispatch('globalstate/removeFromLoading', response.config.url)
    return response
  },
  error => {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 403
    ) {
      // This is the only work around (at the moment) for situations that
      // CSRF token mismatch.
      // In some cases when we have asynchronous calls, CSRF token won't
      // update properly on client. So we retry the same request.
      if (!error.config.retry) {
        error.config.retry = true
        if (store.state.globalstate.taxChangeLoading === true) {
          store.dispatch('globalstate/unsetTaxChangeLoading')
        } else {
          store.dispatch('globalstate/removeFromLoading', error.config.url)
        }
        return Axios.request(error.config)
      }
    }
    store.dispatch('globalstate/clearLoading')
    throw error
  }
)

Vue.use(VueRouter)

const router = new VueRouter({
  base: '/' + window.vueAppBaseUrl,
  mode: 'history',
  routes: [
    { path: '/cart', name: 'Your order', component: Cart },
    { path: '/payment', name: 'Payment', component: Payment },
    { path: '/success', name: 'Thank you', component: Success }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  // Clean all messages when route changes
  store.dispatch('globalstate/clearMessages')

  // Hack workaround to zendesk widget being loaded asynchronously/deferred. Ideally we can call these without a race.
  if (window.zE !== undefined) {
    const zendeskWidgetEnabledRoutes = ['/cart', '/payment']
    if (zendeskWidgetEnabledRoutes.includes(to.path)) {
      window.zE('webWidget', 'show')
    } else {
      window.zE('webWidget', 'hide')
    }
  }

  next()
})

Vue.use(VueGtm, {
  debug: window.debugEnv // Whether or not display console log debug output (bool)
})

Vue.use(VueCookie)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./vue/checkout.js